import {Component, OnInit} from '@angular/core';
import {ICartImage} from "../../cart/catalog/catalog-models";
import {Constants} from "../../constants";
import {CartUtil} from "../../cart/cart-util";
import {IMPHeroModule} from "../marketing-page.models";
import {MarketingPageUtil} from "../marketing-page-util";
import {LoggerService} from "../../common/logger.service";
import {UsanaObject} from "../../usana-object";

@Component({
    templateUrl: './hero.component.html',
    styleUrls: ['./hero.component.scss'],
    standalone: false
})
export class HeroComponent extends UsanaObject implements OnInit {

    pageUrl: string;
    componentData: IMPHeroModule;
    useLocaleOverride: boolean;
    translationRoot: string;

    mobileImagePath: string;
    desktopImagePath: string;
    contentAlignment: string;
    textStyle: string;
    buttonType: string;
    callToActionUrl: string;

    viewSizeMobile = Constants.VIEWSIZE_MOBILE_MAX;

    constructor(loggerService: LoggerService) {
        super(
            loggerService
        );
    }

    ngOnInit() {
        this.translationRoot = MarketingPageUtil.getTranslationRoot(this.pageUrl,this.componentData.name);
        const cartImages: ICartImage[] = MarketingPageUtil.getCartImagesFromModule(this.componentData);
        this.mobileImagePath = CartUtil.getCartImagePathByType(cartImages, Constants.IMAGE_TYPE_MOBILE);
        this.desktopImagePath = CartUtil.getCartImagePathByType(cartImages, Constants.IMAGE_TYPE_DESKTOP);
        this.contentAlignment = MarketingPageUtil.getAlignmentClass(this.componentData.contentAlignment);
        this.textStyle = MarketingPageUtil.getTextStyleClass(this.componentData.textStyle);
        this.buttonType = MarketingPageUtil.getButtonTypeClass(this.componentData.buttonType);
        this.callToActionUrl = this.componentData.countryDetails[0].callToActionUrl;
    }

    callToActionClick() {
        window.location.href = this.callToActionUrl;
    }
}
